import PropTypes from 'prop-types';
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Kostrad from '../../components/Fact/FactLivsmedelverketsKostrad';
import Information from '../../components/Fact/FactLivsmedelverketsInformation';
import Behall from '../../components/Fact/FactBehallInneborden';
import Bidra from '../../components/Fact/FactBidraTillMatgladje';
import Regelverk from '../../components/Fact/FactRegelverkAttForhallaSigTill';
import Nyckelhalet from '../../components/Fact/FactNyckelhalet';
import Vilseledande from '../../components/Fact/FactVilseledande';
import Relevant from '../../components/Fact/FactRelevantInnehall';
import ValjProdukt from '../../components/Fact/FactValjProduktMedOmsorg';

import s from './Faktabank.css';

class Contact extends React.Component {
  static defaultProps = {
    open: '',
  };

  static propTypes = {
    open: PropTypes.string,
  };

  render() {
    const { open } = this.props;

    return (
      <div className={s.root}>
        <div className={s.container}>
          <Behall open={open === 'behall'} />

          <Bidra open={open === 'bidra'} />

          <Information open={open === 'information'} />

          <Kostrad open={open === 'kostrad'} />

          <Nyckelhalet open={open === 'nyckelhalet'} />

          <Regelverk open={open === 'regelverk'} />

          <Relevant open={open === 'relevant'} />

          <Vilseledande open={open === 'vilseledande'} />

          <ValjProdukt open={open === 'valj-produkt'} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Contact);



// WEBPACK FOOTER //
// ./src/routes/faktabank/Faktabank.js